import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { httpGetCustomerIsDbUploadEnabled } from '@zvoove-market/api';
import { Observable, catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomerDbUploadGuard {
  private http = inject(HttpClient);

  canActivate(): Observable<boolean | UrlTree> {
    // We are catching the error so that the request in the guard failing is not breaking the entire app.
    return httpGetCustomerIsDbUploadEnabled(this.http).pipe(catchError(() => of(false)));
  }
}
